import { render } from "./ImportView.vue?vue&type=template&id=b6be70be&scoped=true"
import script from "./ImportView.vue?vue&type=script&lang=js"
export * from "./ImportView.vue?vue&type=script&lang=js"

import "./ImportView.vue?vue&type=style&index=0&id=b6be70be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6be70be"]])

export default __exports__